import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  ADD_GROWTH_ENTRY_PATH,
  EDIT_GROWTH_ENTRY_PATH,
  GROWTH_CHARTS_ENTRIES_PATH,
  GROWTH_CHARTS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const GrowthCharts = lazy(() => import('./pages/GrowthChartsPage'));
const GrowthEntries = lazy(() => import('./pages/GrowthEntriesPage'));
const AddGrowthEntry = lazy(() => import('./pages/AddGrowthEntryPage'));

export const GROWTH_CHART_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <GrowthCharts />,
    displayTitle: () => 'Growth Charts',
    pageType: PageType.PRIVATE,
    path: GROWTH_CHARTS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.growthCharts,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <GrowthEntries />,
    displayTitle: () => 'Growth Entries',
    pageType: PageType.PRIVATE,
    path: GROWTH_CHARTS_ENTRIES_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.growthCharts,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <AddGrowthEntry />,
    displayTitle: () => 'Add Growth Entry',
    pageType: PageType.PRIVATE,
    path: ADD_GROWTH_ENTRY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.growthCharts,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <AddGrowthEntry isUpdate />,
    displayTitle: () => 'Growth Entries Details',
    pageType: PageType.PRIVATE,
    path: EDIT_GROWTH_ENTRY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.growthCharts,
  },
];
